import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
  status: Yup.string().required("A document must have a status assigned."),
  dueDate: Yup.string().nullable().required("A document must have a due date."),
});
